import { createContext } from 'react';

const defaultContext = {
  value: '',
  setValue: () => null,
};

interface IContextShape {
  value?: string | number;
  setValue: React.Dispatch<React.SetStateAction<string | number>>;
}

const TabsContext = createContext<IContextShape>(defaultContext);

export default TabsContext;
